import FormController from 'controllers/form-controller';
import Cookies from 'js-cookie';
import { sessionViewActivity, sessionDownloadActivity } from 'lib/sessions-manager';
import {
  deleteCompleteEventSources,
  findReferringCategory,
  trackCompleteEvent,
  sendTrackingEvent,
} from 'components/analytics/conversions/tracking';
import {
  JOIN_COMPLETE,
  JOIN_TRIGGERED,
} from 'components/analytics/conversions/constants/actions';

export default class RegistrationsAccountFormController extends FormController {
  connect() {
    super.connect();
    Cookies.set('sessionViewActivity', sessionViewActivity());
    Cookies.set('session-download-activity', sessionDownloadActivity());

    this.trackTriggerEvent();

    // Remove complete_event_sources cookie, in case
    // we're coming from a backend error
    deleteCompleteEventSources();
  }

  checkNewsletterOption() {
    const newsletterOption = document.getElementById('newsletter');

    if (newsletterOption && newsletterOption.checked) {
      sessionStorage.setItem('newsletter_preference', 'newsletter_signup');
    } else {
      sessionStorage.setItem('newsletter_preference', 'no_newsletter_signup');
    }
  }

  validateFields() {
    super.validateFields();

    if (this.formValid) {
      this.trackFormComplete();

      const checkForCollections = this.element.dataset.collectionsAccountCreate;
      const category = checkForCollections === 'true' ? 'Collections' : findReferringCategory(this.element);

      this.continueRegistration();
      trackCompleteEvent({
        action: JOIN_COMPLETE,
        category,
        label: 'Sign_Up-Email',
        dataLayerCompleteAttrs: [
          'email_address',
          'email_hash_md5',
          'email_hash_sha1',
          'sign_in_type',
        ],
      });
    } else {
      super.hideSpinner();
    }
  }

  continueRegistration() {
    if (this.downloadLimitModal) {
      this.element.action = `${this.element.action}?download_limit=true`;
    }

    this.submit();
  }

  get downloadLimitModal() {
    const modalWrapElem = this.element.closest('.ez-session-modal__wrap');
    return modalWrapElem.classList.contains('ez-session-modal__download-limit');
  }

  // Sends Trigger events to Google Analytics based off of 'referring_conversions_category' param
  trackTriggerEvent() {
    const urlParameter = new URLSearchParams(window.location.search);
    const category = urlParameter.get('referring_conversions_category');

    if (!category) return;

    sendTrackingEvent({
      data: {
        category,
        action: JOIN_TRIGGERED,
      },
    });
  }
}
